import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef} from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, setConfig, getConfig, getClientLongName, getPackageTypes } from "../../utils"
import cloneDeep from 'lodash/cloneDeep';
import Form from 'react-bootstrap/Form';
import FormFileUpload from "./../inputs/fileupload";

const ExpensesWithCostsAdmin = () => {

    let navigate = useNavigate();
    const { utilsStore, expenseWithCostsStore }= useStores();
    const { expensesWithCosts, getAll, remove, duplicate, getAllWithOptions/*, setConfig, config*/, upload } = expenseWithCostsStore;
    const { getCurrencies, currencies } = utilsStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    useEffect(() => {
        Promise.all([getCurrencies()]);
    }, []);
  

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {            
        });
        setIsLoading(true);
        getAllWithOptions(newProps).then(() => {
            setIsLoading(false);
        });
    }

    const [validated, setValidated] = useState(false);
    const handleUpload = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {            
            var files = new FormData(event.target)?.getAll("file") ?? [];
            var data = new FormData();

            if (files && files?.length) {
                files?.forEach((f, i) => {
                    data.append(`file`, files[i])
                })
            }          
            
            upload(data).then(() => {
                setValidated(false);
                handleClose();
                tableRef?.current?.resetPage();                
            });
        }
        setValidated(true);
    }
    return (
        <span>
            <ManagementTable name={t('expensesWithCosts')} ref={tableRef} isLoading={isLoading}
            config={{
                size: getConfig("expensesWithCosts", "size"),
                dataState: getConfig("expensesWithCosts", "dataState")
            }}
                onColumnSizeChange={(c) => setConfig("expensesWithCosts", "size", c)}
                onDataStateChange={(c) => { setConfig("expensesWithCosts", "dataState", c) }}
                items={expensesWithCosts?.results} onPageChange={onPageChange} pageCount={expensesWithCosts?.pageCount} total={expensesWithCosts?.count} pageSize={expensesWithCosts?.pageSize} columns={
                    [                        
                        { name: "nameEN" },
                        { name: "nameFR" },                     
                        { name: "company", fn: (v) => v?.name ?? "-" },
                        { name: "winbizGL",},                        
                    ]}            
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },                    
                    { text: t('copy'), icon: solid("copy"), onClick: (id) => { duplicate(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmCopy"), modalTitle: t("copy") },
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
            />
        </span>

    );

   
};

export default observer(ExpensesWithCostsAdmin);
